import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./CampusLife.css";

/* Custom Arrows */
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow custom-next" onClick={onClick}>
    ❯
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow custom-prev" onClick={onClick}>
    ❮
  </div>
);

const campusData = [
  {
    title: "Campus Map",
    image: "/campuslife/college.JPG",
    link: "/campuslife/college-buildings",
  },
  {
    title: "Library",
    image: "/campuslife/library.JPG",
    link: "/library",
  },
  {
    title: "ICT Labs",
    image: "/campuslife/ictlab.JPG",
    link: "/campuslife/ict-labs",
  },
  {
    title: "Science Labs",
    image: "/campuslife/sciencelab.JPG",
    link: "/campuslife/science-labs",
  },
  {
    title: "Hostels",
    image: "/campuslife/hostel.JPG",
    link: "/hostels",
  },
  {
    title: "NSS",
    image: "/campuslife/nss-banner.jpg",
    link: "/campuslife/nss",
  },
  {
    title: "Sports",
    image: "/campuslife/sports.JPG",
    link: "/campuslife/sports",
  },
  {
    title: "Auditorium",
    image: "/campuslife/auditorium.JPG",
    link: "/campuslife/auditorium",
  },
];

const CampusLife = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };

  return (
    <section className="campus-life-section">
      <div className="campus-life-container">
        <h2>Campus Life</h2>

        <Slider {...settings}>
          {campusData.map((item, index) => (
            <div key={index}>
              <div className="campus-card">
                <div className="card-image">
                  <img src={item.image} alt={item.title} />

                  <div className="overlay">
                    <h3>{item.title}</h3>

                    <Link to={item.link} className="btn">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default CampusLife;